import { useLocation } from 'react-router-dom';
import JsonLD from './JsonLD';

const breadcrumbMap: Record<string, { label: string; parent?: string }> = {
  '/o-mnie': { label: 'O mnie' },
  '/oferta': { label: 'Oferta' },
  '/dla-firm': { label: 'Dla firm' },
  '/jak-dzialam': { label: 'Jak działam' },
  '/analiza': { label: 'Analiza finansowa' },
  '/faq': { label: 'FAQ' },
  '/kontakt': { label: 'Kontakt' },
  '/doradca360': { label: 'Expert Kredytowy' },
  '/narzedzia': { label: 'Narzędzia' },
  '/narzedzia/nadplata-kredytu': { label: 'Nadpłata kredytu', parent: '/narzedzia' },
  '/narzedzia/refinansowanie': { label: 'Refinansowanie', parent: '/narzedzia' },
  '/narzedzia/zdolnosc-kredytowa': { label: 'Zdolność kredytowa', parent: '/narzedzia' },
  '/narzedzia/kredyt-firmowy': { label: 'Kredyt firmowy', parent: '/narzedzia' },
  '/narzedzia/leasing-vs-kredyt': { label: 'Leasing vs kredyt', parent: '/narzedzia' },
  '/narzedzia/konsolidacja': { label: 'Konsolidacja kredytów', parent: '/narzedzia' },
  '/polityka-prywatnosci': { label: 'Polityka prywatności' },
  '/rodo': { label: 'RODO' },
  '/blog': { label: 'Blog' },
  '/kredyt-hipoteczny-sanok': { label: 'Kredyt hipoteczny Sanok' },
  '/kredyt-gotowkowy-sanok': { label: 'Kredyt gotówkowy Sanok' },
  '/kredyt-firmowy-sanok': { label: 'Kredyt firmowy Sanok' },
  '/refinansowanie-kredytu-sanok': { label: 'Refinansowanie kredytu Sanok' },
};

export function getBreadcrumbs(pathname: string): { label: string; path: string }[] {
  const normalizedPath = pathname === '/' ? '/' : pathname.replace(/\/+$/, '');
  const crumbs: { label: string; path: string }[] = [
    { label: 'Strona główna', path: '/' },
  ];
  let info = breadcrumbMap[normalizedPath];
  if (!info && normalizedPath.startsWith('/blog/')) {
    const articleLabel = normalizedPath.split('/').pop()?.replace(/-/g, ' ') ?? 'Artykuł';
    info = { label: articleLabel, parent: '/blog' };
  }
  if (!info) return crumbs;
  if (info.parent) {
    const parentInfo = breadcrumbMap[info.parent];
    if (parentInfo) {
      crumbs.push({ label: parentInfo.label, path: info.parent });
    }
  }
  crumbs.push({ label: info.label, path: normalizedPath });
  return crumbs;
}

export default function Breadcrumb() {
  const location = useLocation();
  const crumbs = getBreadcrumbs(location.pathname);

  if (crumbs.length <= 1) return null;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: crumb.label,
      item: `https://kredytpodkarpacie.pl${crumb.path === '/' ? '/' : crumb.path}`,
    })),
  };

  return (
    <><JsonLD data={schema} /><nav aria-label="Breadcrumb" className="mb-4">
      <ol className="flex flex-wrap items-center justify-center gap-1 text-xs text-foreground-400">
        {crumbs.map((crumb, i) => (
          <li key={crumb.path} className="flex items-center gap-1">
            {i > 0 && (
              <span className="text-foreground-300 select-none">/</span>
            )}
            {i === crumbs.length - 1 ? (
              <span className="text-foreground-600 font-medium">{crumb.label}</span>
            ) : (
              <a
                href={crumb.path}
                className="hover:text-primary-500 transition-colors cursor-pointer"
              >
                {crumb.label}
              </a>
            )}
          </li>
        ))}
      </ol>
    </nav></>
  );
}
